import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";
import { RadioList } from "./RadioList";
import { Repeater, RepeaterItem } from "./Repeater";

export class F08_2014 extends BaseForm {
    override updateForm() {

        //this.JOINT_PROCUREMENT_INVOLVED_change();
        //this.ADDRESS_FURTHER_INFO_change();
        //this.URL_TOOL_use_change();
        //this.economic_criteria_change;
        //this.DOCUMENT_change();
    }
}

//    JOINT_PROCUREMENT_INVOLVED_change() {
//        this.muVisible((this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked, "PROCUREMENT_LAW_block");
//    }

//    ADDRESS_FURTHER_INFO_change() {
//        const v = this.muNamedWidget.ADDRESS_FURTHER_INFO.muFetchData() as string;
//        this.muVisible(v == "ADDRESS", "ADDRESS_FURTHER_INFO_ADDRESS");
//    }

//    URL_TOOL_use_change() {
//        this.muVisible((this.ui.URL_TOOL_use as HTMLInputElement).checked, "URL_TOOL");
//    }

//    economic_criteria_change() {
//        this.muVisible((this.ui.economic_criteria as HTMLInputElement).checked, "financial_info_criteria");
//        this.muVisible((this.ui.economic_criteria as HTMLInputElement).checked, "financial_min_level_standarts");
//    }

//    DOCUMENT_change() {
//        const v = this.muNamedWidget.DOCUMENT.muFetchData() as string;
//        //this.muVisible(v == "RESTRICTED", "url_restriction");
//        //this.muVisible(v == "FULL", "url_restriction");
//        this.muVisible(!!v, "url_restriction")
//    }
//}

//    export class F02_2014_PARTICIPATION extends BaseWidget {
//    updateForm() {
//        this.type_change();
//        this.URL_change();
//    }

//    URL_change() {
//        this.muVisible((this.ui.URL as HTMLInputElement).checked, "URL_block");
//    }

//    type_change() {
//        const v = this.muNamedWidget.type.muFetchData() as string;
//        this.muVisible(v == "ADDRESS", "ADDRESS");
//        //this.muVisible(v == "URL", "URL_block");
//    }
